/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Audit_Details_Integration_Bound_DescInputs */



/**
* | output |
* | --- |
* | "The {provider} integration was connected for the organisation." |
*
* @param {Audit_Details_Integration_Bound_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_integration_bound_desc = /** @type {((inputs: Audit_Details_Integration_Bound_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Integration_Bound_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Integration ${i?.provider} wurde für die Organisation verbunden.`)
	return /** @type {LocalizedString} */ (`The ${i?.provider} integration was connected for the organisation.`)
});